import React from "react";

import type { ManagementAppRouter } from "@daytrip/api";
import { createTRPCReact } from "@trpc/react-query";

export const apiTrpcReact = createTRPCReact<ManagementAppRouter>({
    // using isolated context to enable multiple TRPC providers
    context: React.createContext(null) as any,
});
